import { render, staticRenderFns } from "./MusicDifficultyStatus.vue?vue&type=template&id=0c8f4c66&scoped=true&lang=pug&"
import script from "./MusicDifficultyStatus.vue?vue&type=script&lang=js&"
export * from "./MusicDifficultyStatus.vue?vue&type=script&lang=js&"
import style0 from "./MusicDifficultyStatus.vue?vue&type=style&index=0&id=0c8f4c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f4c66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
